var _path, _g, _path2, _g2, _path3, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCropsTomato(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_138_9277)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_138_9277",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 45,
    height: 42
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45 2H0V43.0365H45V2Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_138_9277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.9389 14.1394C13.6687 16.3351 12.5163 18.2077 11.4992 20.1589C11.1588 20.8093 11.1806 21.6474 11.0365 22.3982C11.8223 22.3284 12.704 22.4593 13.385 22.1494C16.1961 20.8661 18.933 19.4212 21.7311 18.1117C22.1763 17.9021 22.8791 17.8934 23.32 18.0986C25.9914 19.3426 28.6192 20.6871 31.2689 21.9748C31.7621 22.2149 32.2859 22.4811 32.8141 22.5248C33.2419 22.5597 33.8181 22.3982 34.1018 22.1057C34.2895 21.9137 34.1891 21.2633 34.0101 20.9315C32.7923 18.7097 31.522 16.5184 30.1427 14.1045C32.0808 13.1354 33.901 11.9481 35.9002 11.3676C36.686 11.1406 37.9606 12.1489 38.8511 12.808C47.4765 19.2117 46.6952 30.8709 38.5935 37.4491C32.6002 42.3119 25.7077 43.8877 18.06 42.6174C12.0973 41.6265 7.05554 39.0861 3.4194 34.2582C-2.45168 26.4621 -0.661983 16.7323 8.01587 11.5422C8.38691 11.3195 9.03294 11.2322 9.40398 11.4025C11.2504 12.2406 13.0445 13.1878 14.9389 14.1394Z",
    fill: "#F0452E"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_138_9277",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 45,
    height: 42
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45 2H0V43.0365H45V2Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_138_9277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.6207 14.3926C24.1398 14.3838 25.6807 13.2489 25.7025 12.1183C25.7243 10.966 24.0918 9.81792 22.468 9.84848C20.8834 9.87904 19.587 10.835 19.5521 11.9961C19.5215 13.2358 21.01 14.4013 22.6207 14.3926ZM8.26824 8.79212C11.2452 9.02784 14.231 9.18498 17.1949 9.52983C18.6572 9.70007 19.3164 9.09332 19.7965 7.85799C20.4687 6.10757 21.2326 4.39208 21.9834 2.67223C22.0882 2.44088 22.3457 2.275 22.6076 2C23.6465 4.20875 24.7073 6.30401 25.5978 8.46474C25.9688 9.36395 26.4446 9.60403 27.322 9.52546C30.4649 9.24609 33.6121 9.00601 36.8423 8.74411C36.7201 8.93181 36.624 9.26792 36.4145 9.37268C34.2538 10.4552 32.0712 11.4985 29.9018 12.5679C28.3085 13.3537 28.2037 13.7902 29.1466 15.3529C30.1375 16.9985 31.1109 18.6486 31.8792 20.591C30.2684 19.8402 28.5093 19.2946 27.0732 18.295C24.0045 16.1604 21.1628 16.0251 18.0548 18.2382C16.5751 19.2946 14.7504 19.8664 12.6814 20.8442C14.2092 18.1989 15.4925 15.9858 16.8762 13.585C13.8556 12.0136 10.9659 10.5076 8.07617 9.00165C8.14601 8.93181 8.20713 8.86196 8.26824 8.79212Z",
    fill: "#36965C"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_138_9277",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 2,
    width: 45,
    height: 42
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 2H0V43.0365H45V2Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_138_9277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.3876 12.5505H20.6816C21.8908 11.0184 23.0868 11.0009 24.3876 12.5505Z",
    fill: "#36965C"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_138_9277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCropsTomato);
export default __webpack_public_path__ + "static/media/ic-crops-Tomato.4fb3ba094c15002ff4b022b4722c116a.svg";
export { ForwardRef as ReactComponent };